import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web-app/frontend/src/app/[locale]/faq/page.tsx");
